export enum TabTypes {
  Home,
  Stats,
  Library,
  Videos,
  Roadmap,
  Account,
  Help,
  null,
}
